import { SpotInterface, VisibilityPageSection } from 'types';

export const getVisibilityPageSections = (spot: SpotInterface): VisibilityPageSection[] => {
    const configuredSections = spot.spot_config.visibility_page_sections;
    const sections =
        Array.isArray(configuredSections) && configuredSections.length > 0
            ? configuredSections
            : [VisibilityPageSection.STATS];

    return sections.length > 0 ? sections : [VisibilityPageSection.STATS];
};
